import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=230f0b0b&scoped=true"
import script from "@/views/Settings/Materials/Materials.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Materials/Materials.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Materials/materials.scss?vue&type=style&index=0&id=230f0b0b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f0b0b",
  null
  
)

export default component.exports